module.exports = __webpack_public_path__ + "static/media/similMaderaCarmin.3844435f.jpg";